import { PrincipalDesktopNavigation } from './components/PrincipalDesktopNavigation';
import { PrincipalMobileNavigation } from './components/PrincipalMobileNavigation';
import { useScreenSize } from 'hooks/styling/useScreenSize';

export const PrincipalNavbar = () => {
  const isDesktopScreenSize = useScreenSize('md');

  if (isDesktopScreenSize) {
    return <PrincipalDesktopNavigation />;
  } else {
    return <PrincipalMobileNavigation />;
  }
};
